import { createFileRoute } from "@tanstack/react-router";

import { SetPasswordForm } from "@/components/SetPasswordForm";

export const Route = createFileRoute("/_authenticated/set-password")({
  component: SetPasswordPage,
});

function SetPasswordPage() {
  return <SetPasswordForm />;
}
